export default {
      id: "arrow-left-usage",
      viewBox: "0 0 21 20",
      url: __webpack_public_path__ + "img/icons.79e00d12.svg#arrow-left",
      toString: function () {
        return this.url;
      }
    }